<script>
  export default {
    name: "Paragraph",
    props: {
      styles: {
        type: Object,
        default: () => ({}),
      },
      className: {
        type: String,
        default: "",
      },
      text: {
        type: String,
        default: "",
      },
      variant: {
        type: String,
        default: "",
      },
    },
  };
</script>

<template>
  <p :class="[`Paragraph ${className}`, `Paragraph--${variant}`]" :style="styles">{{ text }}</p>
</template>

<style lang="scss">
  .Paragraph {
    font-size: 16px;
    color: #000;

    &--alert {
      font-size: 12px;
      color: $primary-color;
    }
  }
</style>
